import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const QuotedMessageZipFileIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M9.33317 1.33337H3.99984C3.2665 1.33337 2.67317 1.93337 2.67317 2.66671L2.6665 13.3334C2.6665 14.0667 3.25984 14.6667 3.99317 14.6667H11.9998C12.7332 14.6667 13.3332 14.0667 13.3332 13.3334V5.33337L9.33317 1.33337ZM11.9998 13.3334H3.99984V2.66671H8.6665V6.00004H11.9998V13.3334Z" />
    <path d="M4.6665 9.33337H7.33317V12C7.33317 12.7364 6.73622 13.3334 5.99984 13.3334C5.26346 13.3334 4.6665 12.7364 4.6665 12V9.33337Z" />
    <rect x="4.6665" y="2.66663" width="1.33333" height="1.33333" />
    <rect x="6" y="4" width="1.33333" height="1.33333" />
    <rect x="4.6665" y="5.33337" width="1.33333" height="1.33333" />
    <rect x="6" y="6.66663" width="1.33333" height="1.33333" />
    <rect x="4.6665" y="8" width="1.33333" height="1.33333" />
    <rect x="6" y="9.33337" width="1.33333" height="1.33333" />
    <ellipse cx="6.00016" cy="12" rx="0.666667" ry="0.666667" fill="white" />
  </Icon>
);

export default memo(QuotedMessageZipFileIcon);
